import React, { memo } from 'react';
import classNames from 'classnames';

import Popup from '../helpers/Popup';
import Button from '../helpers/Button';
import FormGroup from '../helpers/FormGroup';
import FieldError from '../helpers/FieldError';
import FormErrors from '../helpers/FormErrors';
import Input from '../helpers/Input';
import Select from '../helpers/Select';

const EditTagPopup = ({
  isNew,
  category,
  errors,
  showParent,
  tagTypeId,
  parentId,
  parents,
  types,
  loading,
  onChange,
  onSave,
  onCancel,
}) => {
  const footer = (
    <>
      <Button className="btn-primary" disabled={loading} onClick={onSave}>
        Save
      </Button>
      <Button disabled={loading} onClick={onCancel}>
        Cancel
      </Button>
    </>
  );

  return (
    <Popup footer={footer} header={isNew ? 'Add Tag' : 'Edit Tag'} id="editTag" loading={loading}>
      <FormGroup className={classNames({ 'has-error': errors.category })}>
        <Input label="Tag Name" name="category" onChange={onChange} value={category} autoFocus showLabel />
        <FieldError message={errors.category} />
      </FormGroup>
      <FormGroup className={classNames({ 'has-error': errors.tagTypeId })}>
        <Select
          defaultText=" "
          defaultValue=""
          label="Tag Type"
          name="tagTypeId"
          nameKey="type"
          onChange={onChange}
          options={types}
          value={tagTypeId}
          valueKey="id"
          showLabel
        />
        <FieldError message={errors.tagTypeId} />
      </FormGroup>
      {showParent && (
        <FormGroup className={classNames({ 'has-error': errors.parentId })}>
          <Select
            defaultText=" "
            defaultValue=""
            label="Parent Category"
            name="parentId"
            nameKey="category"
            onChange={onChange}
            options={parents}
            value={parentId}
            valueKey="id"
            showLabel
          />
          <FieldError message={errors.parentId} />
        </FormGroup>
      )}
      <FormErrors errors={errors.form} />
    </Popup>
  );
};

export default memo(EditTagPopup);
